// extracted by mini-css-extract-plugin
export default {"wrapper":"MultipleSelectImageButtons_wrapper__05qZs","button":"MultipleSelectImageButtons_button__F3Myl","active":"MultipleSelectImageButtons_active__LfE8k"};